export const sortSearchFilters = (arrValue) => {
    let d = arrValue.slice();
    let r = d.sort((p1, p2) =>
        //Place parcel layer first in the list
        p1.DisplayName === "Parcel" && p1.DisplayName === p2.DisplayName
            ? //Sort Parcels by Field Display Name
              p1.FieldDisplayName < p2.FieldDisplayName
                ? -1
                : p1.FieldDisplayName > p2.FieldDisplayName
                ? 1
                : 0
            : p1.DisplayName < p2.DisplayName
            ? -1
            : p1.DisplayName > p2.DisplayName
            ? 1
            : //Layer Display Name same sort by Field Display Name
            p1.FieldDisplayName < p2.FieldDisplayName
            ? -1
            : p1.FieldDisplayName > p2.FieldDisplayName
            ? 1
            : 0
    );
    return r;
};
export const sortSearchQueryFilters = (arrValue) => {
    let d = arrValue.slice();
    let r = d.sort((p1, p2) =>
        //Place parcel layer first in the list
        p1.DisplayName === "Parcel" && p1.DisplayName === p2.DisplayName
            ? //Sort Parcels by Field Display Name
              p1.FieldDisplayName < p2.FieldDisplayName
                ? -1
                : p1.FieldDisplayName > p2.FieldDisplayName
                ? 1
                : 0
            : p1.DisplayName < p2.DisplayName
            ? -1
            : p1.DisplayName > p2.DisplayName
            ? 1
            : //Layer Display Name same sort by Field Display Name
            p1.FieldDisplayName < p2.FieldDisplayName
            ? -1
            : p1.FieldDisplayName > p2.FieldDisplayName
            ? 1
            : 0
    );
    return r;
};
